export const NSFW_TAGS = {
  mature: ['nsfw', 'suggestive', 'risque', 'suggestive-content'],
  explicit: ['explicit', 'porn', 'sexy', 'adult-content']
} as const;

// Helper function to check if a tag is NSFW and what category it belongs to
export function getNSFWCategory(tag: string) {
  if (NSFW_TAGS.explicit.includes(tag)) return 'explicit';
  if (NSFW_TAGS.mature.includes(tag)) return 'mature';
  return null;
}

// Helper to get all NSFW tags
export const ALL_NSFW_TAGS = [...NSFW_TAGS.mature, ...NSFW_TAGS.explicit]; 